import { Shield } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ReadyToStartTheConversation() {
  return <section data-section-id="184879" id="begin-your-journey-today" className="dark bg-background text-foreground relative overflow-hidden py-32 px-6 lg:px-8 flex flex-col items-center justify-center text-center isolate">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none -z-10 overflow-hidden">
        <Shield className="w-[120vw] h-[120vw] max-w-[1200px] max-h-[1200px] text-secondary opacity-10 rotate-45" strokeWidth={0.1} aria-hidden="true" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto flex flex-col items-center">
        <h2 className="text-5xl md:text-6xl lg:text-8xl font-default font-bold text-white tracking-tight mb-8 leading-tight">
          Begin Your Journey Today
        </h2>
        
        <p className="text-xl md:text-2xl text-muted-foreground max-w-2xl mb-12 font-default">
          Where ambition meets achievement. Partner with Briviox to navigate the complexities of international admissions and secure your academic future.
        </p>

        <Button asChild size="lg" className="text-lg h-auto px-10 py-5 rounded-sm shadow-2xl hover:scale-105 transition-all duration-300 ease-out bg-white text-background hover:bg-white/90">
          <Link to="#">
            Book Professional Assessment
          </Link>
        </Button>
      </div>
    </section>;
}